"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useApplyCheck = void 0;
var axios_1 = __importDefault(require("axios"));
var nookies_1 = require("nookies");
var react_1 = require("react");
var react_router_1 = require("react-router");
var query_string_1 = __importDefault(require("query-string"));
var useApplyCheck = function () {
    var navigate = (0, react_router_1.useNavigate)();
    var search = (0, react_router_1.useLocation)().search;
    var params = query_string_1.default.parse(search);
    var cookies = (0, nookies_1.parseCookies)();
    var _a = (0, react_1.useState)(false), LineLoginError = _a[0], setLineLoginError = _a[1];
    var loginLine = function (code) { return __awaiter(void 0, void 0, void 0, function () {
        var lineUser;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios_1.default
                        .post("/api/line/user", {
                        redirect_uri: "/main/apply/check",
                        code: code,
                    })
                        .then(function (data) {
                        return JSON.parse(data.data);
                    })
                        .catch(function (_a) {
                        var response = _a.response;
                        return response.data;
                    })];
                case 1:
                    lineUser = _a.sent();
                    return [2 /*return*/, lineUser];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var lineUserData, user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(params.state && cookies.state === params.state)) return [3 /*break*/, 7];
                        if (params.error) {
                            setLineLoginError(true);
                        }
                        if (!params.code || Array.isArray(params.code))
                            return [2 /*return*/];
                        return [4 /*yield*/, loginLine(params.code)];
                    case 1:
                        lineUserData = _a.sent();
                        if (lineUserData.error) {
                            setLineLoginError(true);
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, axios_1.default
                                .get("/api/user", {
                                headers: {
                                    Authorization: "Bearer " + localStorage.getItem("token"),
                                },
                            })
                                .then(function (data) {
                                return data.data;
                            })
                                .catch(function (_a) {
                                var response = _a.response;
                                return null;
                            })];
                    case 2:
                        user = _a.sent();
                        if (!(!(user === null || user === void 0 ? void 0 : user.user_id) || (user === null || user === void 0 ? void 0 : user.line_uid))) return [3 /*break*/, 4];
                        return [4 /*yield*/, axios_1.default
                                .post("/api/login/line", {
                                line_uid: lineUserData.userId,
                                name: lineUserData.displayName,
                            })
                                .then(function (result) { return __awaiter(void 0, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    if (result.data.token) {
                                        localStorage.setItem("token", result.data.token);
                                    }
                                    navigate("/main/apply/form");
                                    return [2 /*return*/];
                                });
                            }); })
                                .catch(function (_a) {
                                var response = _a.response;
                                if (response.data.type === "internal_server_error") {
                                    alert(response.data.message);
                                }
                                if (response.data.type === "bad_request") {
                                    alert(response.data.message);
                                }
                                navigate("/main/apply");
                            })];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        if (!(localStorage.getItem("token") !== "guest")) return [3 /*break*/, 6];
                        // 展示会ログイン済みユーザ（LINE連携）
                        return [4 /*yield*/, axios_1.default
                                .post("/api/line/cooperation", {
                                line_uid: lineUserData.userId,
                                name: lineUserData.displayName,
                            }, {
                                headers: {
                                    Authorization: "Bearer " + localStorage.getItem("token"),
                                },
                            })
                                .then(function (result) { return __awaiter(void 0, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    if (result.data.token) {
                                        localStorage.setItem("token", result.data.token);
                                    }
                                    navigate("/main/apply/form");
                                    return [2 /*return*/];
                                });
                            }); })
                                .catch(function (_a) {
                                var response = _a.response;
                                if (response.data.type === "internal_server_error") {
                                    alert(response.data.message);
                                }
                                if (response.data.type === "bad_request") {
                                    alert(response.data.message);
                                }
                                navigate("/main/apply");
                            })];
                    case 5:
                        // 展示会ログイン済みユーザ（LINE連携）
                        _a.sent();
                        _a.label = 6;
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        alert("認証に失敗しました。恐れ入りますが、再度認証手続きを行ってください。");
                        navigate("/main/apply");
                        _a.label = 8;
                    case 8: return [2 /*return*/];
                }
            });
        }); })();
    }, []);
    return { LineLoginError: LineLoginError };
};
exports.useApplyCheck = useApplyCheck;
